import { Injectable } from '@angular/core';
import { FundDDQRunQuery } from '@core/fund-ddq-run/fund-ddq-run.query';
import { ProductQuery } from '@core/product/product.query';
import { FundDDQRun } from '@core/models/fund-ddq-run.model';
import { Product } from '@core/models/product.model';

/**
 * Builds {@link FundDDQRun}-shaped prefill for CreateFundDialog:
 * prefer row data already in the Fund DDQ Akita store, else active {@link Product} (issuer + fund name).
 */
@Injectable({ providedIn: 'root' })
export class CreateFundDialogPrefillService {
  constructor(
    private readonly fundDDQRunQuery: FundDDQRunQuery,
    private readonly productQuery: ProductQuery,
  ) {}

  resolveForProduct(productId: string | null | undefined): FundDDQRun | undefined {
    if (!productId) {
      return undefined;
    }

    const fromStore = this.fundDDQRunQuery.getFundDDQRuns().find((r) => r.productUid === productId);
    if (fromStore) {
      return fromStore;
    }

    const active = this.productQuery.getActive();
    if (!active || Array.isArray(active)) {
      return undefined;
    }

    const product = active as Product;
    if (product.id !== productId && product.uid !== productId) {
      return undefined;
    }

    const issuer = product.emittentCompany;
    const issuerUid = issuer?.id ?? '';
    const issuerCompanyName = issuer?.name ?? '';

    if (!issuerCompanyName && !product.productName) {
      return undefined;
    }

    return {
      issuerUid,
      issuerCompanyName,
      productUid: productId,
      productName: product.productName ?? '',
      ddqRunCount: 0,
    };
  }
}
